export { AbstractComponent } from './src/abstractComponent';
export { AbstractHelpers } from './src/abstractHelpers';
export { Router, RouterRouteRender, type RouterHistory, type RouterRoutable } from './src/decoratorRouter';
export { Behavior } from './src/decoratorBehavior';
export { FontFaces } from './src/decoratorFontFaces';
export { JSXRender } from './src/decoratorJSXRender';
export { I18N, type Locales } from './src/decoratorI18N';
export { Slot } from './src/decoratorSlot';

// import utils
import UtilTimer from "@dia-ui/util_timer";

// import default behaviors
import "@dia-ui/behavior_mailto-handler";
import "@dia-ui/behavior_code-mirror";
import "@dia-ui/behavior_date-picker";
import "@dia-ui/behavior_color-picker";
import "@dia-ui/behavior_image-zoom";
import "@dia-ui/behavior_password-strength";

/**
 * initHas outside of webcomponents
 */
let initHas = () => {
    document.querySelectorAll('[has]').forEach((e) => {
        let has = e.getAttribute("has");

        e.removeAttribute("has");

        UtilTimer.delay(() => {
            e.setAttribute("has", has);
        }, 500);
    });
};

/**
 * on dom ready call initHas or if already done call instantly
 */
if (document.readyState === "loading") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", initHas);
} else {
    // `DOMContentLoaded` has already fired
    UtilTimer.delay(initHas, 500);
}
